module.exports = "<div class=\"live-minto-course container\">\n\n  <mo-header title=\"liveMintoCourse\"></mo-header>\n\n  <main class=\"content wrapper\">\n\n    <mo-nav></mo-nav>\n    <section class=\"content-box\" translate>livecourse.text</section>\n  </main>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/modules/site/livecourse/livecourse.html
// module id = 524
// module chunks = 0